export default function R_Nested_Loop() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Nested_Loop Component</h1>
      <p>This is the R_Nested_Loop tutorial section.</p>
    </div>
  );
}
